import Vue from 'vue'

const MediaPlatformInstance = Vue.extend(require('./mediaPlatformTag.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

let getInstance = () => {
  return new MediaPlatformInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

let MediaPlatformTag = (config, call,i) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise((resolve) => {
    confirmResolve = resolve
  })
  instance.open(config, confirmResolve, call,i)

  return confirmPromise
}

export default MediaPlatformTag
